<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="isRouterAlive" />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
    };
  },
  mounted() {
    if (this._isMobile()) {
       if(window.location.href == 'http://www.bioleaper.com/'){
          window.location.href = 'http://m.bioleaper.com/'
       }else{}
    } else {
       if(window.location.href == 'http://m.bioleaper.com/'){
          window.location.href = 'http://www.bioleaper.com/'
       }else{}
    }
  },
  data() {
    return {
      isRouterAlive: true, //控制视图是否显示的变量
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true; //再打开
      });
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  },
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}
body{
  font-family: "Microsoft YaHei";
}
</style>
